import React from 'react'
import { HomeSection } from '../../index'

function HomeSectionDoubledV2({ sections }) {
  const visibleSections = sections?.filter(section => !section.hidden) || []

  if (visibleSections.length === 0) {
    return null
  }

  const isSingle = visibleSections.length === 1
  const gridCols = isSingle ? 'grid-cols-1' : 'lg:grid-cols-2 grid-cols-1'

  return (
    <div className={`grid ${gridCols} gap-4 items-stretch mx-4 mt-4`}>
      {visibleSections.map((section, i) => (
        <HomeSection
          key={section._key || i}
          {...section}
          useAspectRatio={!isSingle}
          noHorizontalMargin={true}
          marginTop={0}
        />
      ))}
    </div>
  )
}

export default HomeSectionDoubledV2
